import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';

import ButtonContained from '$app-web/components/button-contained';

const ButtonGroup = (props) => {
    const { direction, spacing, buttons } = props;
    return (
        <Grid container direction={direction} spacing={spacing}>
            {buttons.map(({ key, label, wrapperClassName, ...buttonProps }) => (
                <Grid key={key} className={wrapperClassName} item xs>
                    {label && (
                        <Typography variant="body2" align="center" gutterBottom>
                            {label}
                        </Typography>
                    )}
                    <ButtonContained color="secondary" fullWidth {...buttonProps} />
                </Grid>
            ))}
        </Grid>
    );
};

ButtonGroup.propTypes = {
    direction: PropTypes.string.isRequired,
    spacing: PropTypes.number.isRequired,
    buttons: PropTypes.arrayOf(PropTypes.object).isRequired,
};
export default ButtonGroup;
